"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipSpeedDescription = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const ShipSpeedDescription = (props) => {
    const { methodKey, shipSpeedData } = props;
    if (!methodKey)
        return (0, jsx_runtime_1.jsx)("span", { children: 'Shipping information not available' });
    const method = shipSpeedData?.find((item) => item.methodName &&
        item.methodName.toLowerCase() === methodKey.toLowerCase());
    return ((0, jsx_runtime_1.jsx)("span", { children: method?.description ??
            `${capitalizeFirstLetter(methodKey)} shipping method.` }));
};
exports.ShipSpeedDescription = ShipSpeedDescription;
